<template>
    <b-form-group
            v-if="dataIsVisible"
            class="c-date"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <b-form-input
                v-if="readOnly"
                type="text"
                :readonly="true"
                v-model="window.Core.Date.format(dataValue)"></b-form-input>
      <b-form-input
              v-else-if="required"
              type="date"
              :id="id"
              :readonly="readOnly"
              :state="chkState(id)"
              v-model="dataValue"
              :autocomplete="autocomplete"></b-form-input>
        <b-form-input
                v-else
                type="date"
                :id="id"
                :readonly="readOnly"
                v-model="dataValue"
                :autocomplete="autocomplete"></b-form-input>
      <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
        {{invalidFeedbackMessage}}
      </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
  export default {
      name: 'InputDate',
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          _isVisible: {
              type: Boolean,
              default: true
          }
      },
      computed: {
          isVisible: {
              get() {
                  return this.dataIsVisible
              },
              set(val) {
                  this.dataIsVisible = val
              }
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataIsVisible = this._isVisible
          this.dataValue = this.value
      },
      data: () => {
          return {
              window: window,
              dataValue: '',
              dataIsVisible: true
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>